import { gql } from 'graphql-request'

export const GET_MY_PURCHASED_BOOK_LISTS = gql`
  query GetMyPurchasedBookLists(
    $limitPerPage: Int
    $page: Int
    $bookType: [BookType!]
    $chapterType: ChapterType
    $isEbook: Boolean
    $categoryIds: [Int!]
    $shelfBookDisplay: ShelfBookDisplay
    $searchText: String
  ) {
    getMyPurchasedBookLists(
      limitPerPage: $limitPerPage
      page: $page
      bookType: $bookType
      chapterType: $chapterType
      isEbook: $isEbook
      categoryIds: $categoryIds
      shelfBookDisplay: $shelfBookDisplay
      searchText: $searchText
    ) {
      page
      total
      data {
        writer
        id
        penName {
          firstPenName
          user {
            displayName
            profilePageSlug
            writer {
              affiliation
            }
          }
        }
        title
        cover
        coverImgPath
        coverResizeImgPath
        category {
          id
          name
        }
        hasSalePromotions
        buyAllChaptersPromotion {
          startDate
          endDate
          discountType
          discountPercentage
        }
        readFreePromotion {
          startedAt
          endedAt
        }
        bookBadges {
          badgeCategoryId
          badgeImageUrl
        }
        bookChapterCampaignHeader {
          minSellingPrice
          totalChapter
          startedAt
          endedAt
        }
        isEnded
        bookType
        isEbook
        isTranslated
        likeCount
        viewCount
        commentCount
        isLiked
        publishedChapterCount
        chapterPurchasedCount
        tags {
          id
          name
        }
      }
    }
  }
`
